'use client';
import cn from 'classnames';
import Image from 'next/image';

import Text from '@/components/common/Text/Text';
import Button from '@/components/common/Button/Button';
import Link from '@/components/common/Link/Link';

import WelcomeToLogo from 'public/img/logo/Welcome-To.png';
import ReserveTextLogo from 'public/img/logo/reserve-logo-white.svg';

import './PriveeHeroBanner.style.scss';

const PRIVEE_VIDEO_MWEB =
  'https://d20cg60zeycvr1.cloudfront.net/videos/privee-video-reveal-1-mweb-compressed.mp4';
const PRIVEE_VIDEO_DESKTOP =
  'https://d20cg60zeycvr1.cloudfront.net/videos/privee-video-reveal-1-rectangle-desktop-compressed.mp4';

type PriveeHeroBannerProps = {
  className?: string;
};

function PriveeHeroBanner(props: PriveeHeroBannerProps) {
  const { className = '' } = props;

  return (
    <div className={cn('PriveeHeroBanner', className)}>
      <div className='PriveeHeroBanner-media'>
        <video
          className='PriveeHeroBanner-video'
          autoPlay
          loop
          muted
          playsInline
          preload='metadata'
        >
          <source
            src={PRIVEE_VIDEO_DESKTOP}
            media='(min-width: 1000px)'
          />
          <source src={PRIVEE_VIDEO_MWEB} />
        </video>
      </div>
      <div className='PriveeHeroBanner-content'>
        <div className='PriveeHeroBanner-title'>
          <Image
            className='PriveeHeroBanner-title-script'
            src={WelcomeToLogo}
            alt='Welcome to'
            height={60}
            width={200}
          />
          <Image
            className='PriveeHeroBanner-title-logo'
            src={ReserveTextLogo}
            alt='Réservé'
            height={72}
            width={228}
          />
        </div>
        <Text
          className='PriveeHeroBanner-description'
          variant='text-m'
        >
          As a Réservé member, you unlock access to an ultra-curated collection
          of rare, fully authenticated pieces reserved and curated exclusively
          for those invited into the tier.
        </Text>
        <Text
          className='PriveeHeroBanner-description'
          variant='text-m'
        >
          Enjoy your dedicated VIP concierge and separate R&eacute;serv&eacute;
          closet, seamlessly layered onto your Vivrelle membership.
        </Text>
        <Link href='/how-it-works-reserve'>
          <Button
            className='PriveeHeroBanner-cta'
            variant='dark'
            size='large'
          >
            ABOUT RÉSERVÉ
          </Button>
        </Link>
      </div>
    </div>
  );
}

export default PriveeHeroBanner;
